import React from 'react'

import { Form, Col } from '_zari/core'

const DocumentoNotaFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='DOC NOTA' htmlFor='input-docNota' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.InputText disabled id='input-docNota' name='input-docNota' placeholder={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(DocumentoNotaFormGroup)
